import { Link, NavLink, useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { ShoppingBag, Menu, X, Globe } from "lucide-react";
import { useState, useEffect } from "react";

const LOGO = "https://customer-assets.emergentagent.com/job_7f06c548-253d-46ff-97f6-8e1ce04a5d90/artifacts/754hzicm_4D591E6D-6750-40B9-B6EF-BB93EB677B89.png";

export const Navbar = () => {
    const { lang, setLang, t, cartCount, setCartOpen } = useApp();
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const loc = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => { setOpen(false); }, [loc.pathname]);

    const toggleLang = () => setLang(lang === "ar" ? "en" : "ar");

    const links = [
        { to: "/", label: t.nav.home },
        { to: "/products", label: t.nav.products },
        { to: "/about", label: t.nav.about },
        { to: "/contact", label: t.nav.contact },
    ];

    return (
        <header
            data-testid="main-navbar"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled ? "bg-black/85 backdrop-blur-xl border-b border-[#D4AF37]/20" : "bg-transparent"
            }`}
        >
            <div
                data-testid="discount-announcement-bar"
                className="w-full bg-[#D4AF37] text-black text-center text-xs sm:text-sm font-semibold tracking-wider py-2 px-4"
            >
                {lang === "ar"
                    ? "✦ خصم 25٪ على جميع منتجات سرى للخيام — لفترة محدودة ✦"
                    : "✦ 25% OFF on all SRAA TENT products — Limited time ✦"}
            </div>
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-4 flex items-center justify-between gap-6">
                <Link to="/" data-testid="navbar-logo-link" className="flex items-center gap-3">
                    <img src={LOGO} alt="SRAA TENT" className="h-12 w-auto" />
                </Link>

                <nav className="hidden lg:flex items-center gap-10">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-link-${l.to.replace('/', '') || 'home'}`}
                            className={({ isActive }) =>
                                `text-sm tracking-widest ${lang === 'ar' ? 'tracking-normal' : 'uppercase'} transition-colors ${
                                    isActive ? "text-[#D4AF37]" : "text-white/80 hover:text-[#D4AF37]"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <button
                        onClick={toggleLang}
                        data-testid="lang-toggle"
                        className="flex items-center gap-1.5 text-white/80 hover:text-[#D4AF37] transition-colors text-sm"
                    >
                        <Globe size={16} />
                        <span className="font-medium">{lang === "ar" ? "EN" : "AR"}</span>
                    </button>

                    <button
                        onClick={() => setCartOpen(true)}
                        data-testid="cart-button"
                        className="relative text-white/90 hover:text-[#D4AF37] transition-colors p-2"
                        aria-label="Cart"
                    >
                        <ShoppingBag size={20} />
                        {cartCount > 0 && (
                            <span
                                data-testid="cart-count-badge"
                                className="absolute -top-0.5 -end-0.5 bg-[#D4AF37] text-black text-[10px] font-semibold rounded-full h-4 w-4 flex items-center justify-center"
                            >
                                {cartCount}
                            </span>
                        )}
                    </button>

                    <button
                        onClick={() => setOpen((v) => !v)}
                        data-testid="mobile-menu-toggle"
                        className="lg:hidden text-white p-2"
                        aria-label="Menu"
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
            </div>

            {open && (
                <div data-testid="mobile-menu" className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-[#D4AF37]/20">
                    <nav className="flex flex-col py-6 px-6 gap-5">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                className="text-base text-white/90 hover:text-[#D4AF37]"
                            >
                                {l.label}
                            </NavLink>
                        ))}
                    </nav>
                </div>
            )}
        </header>
    );
};
